import { render, staticRenderFns } from "./NoBodiesFound.vue?vue&type=template&id=a73c9048&scoped=true&"
import script from "./NoBodiesFound.vue?vue&type=script&lang=js&"
export * from "./NoBodiesFound.vue?vue&type=script&lang=js&"
import style0 from "./NoBodiesFound.vue?vue&type=style&index=0&id=a73c9048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73c9048",
  null
  
)

export default component.exports